import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootState } from 'src/app/reducers';
import { navigate, openWindow } from '../../../actions/core.actions';
import { RoutingPathResolver } from '../../../app-routing-path-resolver';
import { DOCUMENT } from '@angular/common';
import { NEW_INSTALLATION_URL, INSTALLATION_DIALOG_WIDTH, DIALOG_ZERO_PADDING_PANEL_CLASS } from '../../../resources/config';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { InstallationDialogComponent } from '../../components/top/installation-dialog/installation-dialog.component';

@Component({
  selector: 'app-top-header',
  templateUrl: './top-header.component.html',
  styleUrls: ['./top-header.component.scss']
})
export class TopHeaderComponent implements OnInit {
  newInstallationUrl: string = NEW_INSTALLATION_URL;

  private threshold = 300; // スクロール量がこの値を超えたらヘッダーを表示する
  headerIsShow = false;

  constructor(private store: Store<RootState>, @Inject(DOCUMENT) private document: Document, private dialog: MatDialog) {}

  @HostListener('window:scroll', ['$event'])
  onScroll(e: any) {
    const currentPos: number = e.target.scrollingElement.scrollTop;
    if (currentPos > this.threshold) {
      this.headerIsShow = true;
    } else {
      this.headerIsShow = false;
    }
  }

  ngOnInit() {}

  openInstallationDialog() {
    this.dialog.open(InstallationDialogComponent, {
      width: INSTALLATION_DIALOG_WIDTH,
      panelClass: DIALOG_ZERO_PADDING_PANEL_CLASS,
      autoFocus: false
    });
  }

  gotoSearch() {
    this.store.dispatch(navigate({ url: RoutingPathResolver.resolveSearch() }));
  }
}
